import { z } from 'zod';
/**
 * Make-The-Number ("24") — arithmetic, but not fiddly.
 *
 * You get N numbers and a target. Combine ALL of them, each used exactly once,
 * with + - x / to reach the target. Classic is four numbers to 24; this is
 * seeded and the target varies.
 *
 * The player builds the expression by tapping numbers and operators — no free
 * typing — so every submission is well-formed by construction and the server
 * only has to check it uses each number once and evaluates to the target.
 */
export const TWENTY_FOUR_OPERATORS = ['+', '-', '*', '/'];
/**
 * A submitted solution: a flat token stream the player assembled. Numbers are
 * given as INDICES into the puzzle's number list (so "use each once" is a
 * permutation check), operators/parens as literals.
 */
export const TwentyFourToken = z.union([
    z.object({ t: z.literal('num'), i: z.number().int().min(0).max(15) }),
    z.object({ t: z.literal('op'), op: z.enum(TWENTY_FOUR_OPERATORS) }),
    z.object({ t: z.literal('lparen') }),
    z.object({ t: z.literal('rparen') }),
]);
export const TwentyFourSubmitEvent = z.object({
    type: z.literal('submit'),
    tokens: z.array(TwentyFourToken).min(1).max(32),
});
export const TwentyFourEvent = z.discriminatedUnion('type', [TwentyFourSubmitEvent]);
//# sourceMappingURL=twenty-four.js.map